import * as React from 'react';
import {getRequestConfig, getHostApi} from "./../../../../utils";
import axios from "axios";
import {getUploadRequest, postUploadRequest, putUploadRequest} from "../UploadActions.api";
import {getUserId} from "../../MonCompteAction";
import Icons from "../../Icons";
import {BounceLoader} from "../../BounceLoader";
import {baseUrlEmbrodery, fetchDataFilsExist} from "./EmbroderyUtils";
import Modal from "react-responsive-modal";

interface EmbroderyProps {
  idCommande:number,
  numCommande:string,
  surfaceId: number,
  emplacementId: number,
  fileRegisteredId:number,
  fileRegisteredCreationId: string,
  surfaceEmplacementId: number,
  caddies: any,
  setBroderieId: any,
  setBroderieValide: any,
  validationBat: boolean,
  customerChoice: boolean,
  declencherFetchBroderie: boolean,
  declencherValidationBroderie: boolean,
  declencherDevalidationBroderie: boolean,
  bgColor: string,
  isInternalUserNotCustomerView: boolean,
  isInternalUserAdminNotCustomerView: boolean,
  dimensions: any,
  handleDisplayChargement: any,
  reuploadBtnAdminBatValide: boolean,
  defineNbCouleursMax: (nbCouleursMax: number, nbCouleurs: number) => void,
  getPreview: (idCaddies: string, forceUpdate: boolean, onlyPreview: boolean) => void,
  wantReUseFils: boolean,
  numberfils: number | null,
  traitementContour: string,
  pathBatOriginal: string,
  galerieFichierVariableId: number;
}

export default class Embrodery extends React.Component<EmbroderyProps, any> {
  private timeoutBtns: NodeJS.Timeout | undefined;
  constructor(props: EmbroderyProps) {
    super(props);
    this.state = {
      tolerance: 15,
      idCaddies: this.props.caddies[0].idCaddies,
      displayChargement: false,
      openModaleConfirmChangeFils: false,
      oldReferenceFil: '',
      referenceFil: '',
      codeHexa: '',
      fluorescent: '',
      metallique: ''
    }
  }

  componentDidUpdate(prevProps: Readonly<EmbroderyProps>, prevState: Readonly<any>, snapshot?: any) {
    if(prevProps.declencherFetchBroderie != this.props.declencherFetchBroderie) {
      this._fetchFilsBroderie(this.state.idCaddies, this.state.tolerance, false, true);
    }
    if(prevProps.declencherValidationBroderie != this.props.declencherValidationBroderie) {
      this._validateFilsBroderie(this.state.idCaddies);
    }
    if(prevProps.declencherDevalidationBroderie != this.props.declencherDevalidationBroderie) {
      this._validateFilsBroderie(this.state.idCaddies, true);
    }
  }

  componentDidMount() {
    this._fetchFilsBroderie(this.state.idCaddies, this.state.tolerance, true);
    this._getFeatureNbCouleurs();
  }



  _getFeatureNbCouleurs = () => {
    axios.get(`${getHostApi()}/shops/features/broderie_new_im_version`,
      getRequestConfig()).then((response) => {
      if (response.data.feature) { this.setState({ activateNbCouleurs: response.data.feature }); }
    }).catch(() => { console.error(); });
  }

  _dataFilsBroderie = (idCaddies: string, tolerance: number = 15, onlyInBdd: boolean = false, nbCouleurs: number | null = null) => {
    //onlyInBDD = check si des fils sont validés en bdd pour ce visuel et les récupère au refresh de la page directement sans clic bouton
    const tiff = `${this.props.fileRegisteredCreationId}-${this.props.surfaceEmplacementId}.tiff`;
    let routeFetchFilsUrl = `${baseUrlEmbrodery(idCaddies,this.props.idCommande, this.props.surfaceId, this.props.emplacementId, this.props.fileRegisteredId )}embroidery?tif=${tiff}&onlyInBdd=${onlyInBdd}&tolerance=${tolerance}&traitement=${this.props.traitementContour}&galerieFichierVariableId=${this.props.galerieFichierVariableId}`;
    if(nbCouleurs !== null) {
      routeFetchFilsUrl = `${routeFetchFilsUrl}&nbCouleurs=${nbCouleurs}`;
    }
    const routeMiniatureFils = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.idCommande}/image-files?numCommande=${this.props.numCommande}&path=travail.auto/embroidery/&validated=true&xsrf=${localStorage.getItem('xsrfToken')}&cache=${Date.now()}`;
    const data = {
      "routeFetchFils": routeFetchFilsUrl,
      "routeMiniatureFils": routeMiniatureFils
    }
    return data;
  }

  _dataFilsProcheBroderieFromReference = (idCaddies: string, referenceFil: number) => {
    const baseUrl = baseUrlEmbrodery(idCaddies,this.props.idCommande, this.props.surfaceId, this.props.emplacementId, this.props.fileRegisteredId );
    const data = {
      "routeFetchFils":  `${baseUrl}embroidery/proche/${referenceFil}`
    }
    return data;
  }

  _updateDataFilsProcheBroderieFromReference = (idCaddies: string, referenceFil: number) => {
    const baseUrl = baseUrlEmbrodery(idCaddies,this.props.idCommande, this.props.surfaceId, this.props.emplacementId, this.props.fileRegisteredId );
    const data = {
      "routeFetchFils":  `${baseUrl}embroidery/proche/${referenceFil}`,
      "creationIdSurface": `${this.props.fileRegisteredCreationId}-${this.props.surfaceEmplacementId}`,
      "routeMiniatureFils": `${getHostApi()}/customers/${getUserId()}/orders/${this.props.idCommande}/image-files?numCommande=${this.props.numCommande}&path=travail.auto/embroidery/&validated=true&xsrf=${localStorage.getItem('xsrfToken')}&cache=${Date.now()}`,
    }
    return data;
  }

  _validateDataFilsBroderie = (idCaddies: string, isDevalidation: boolean = false, isDeleteFile: boolean = false) => {
    const baseUrl = baseUrlEmbrodery(idCaddies,this.props.idCommande, this.props.surfaceId, this.props.emplacementId, this.props.fileRegisteredId );
    const data = {
      "routeValidateFils": `${baseUrl}embroidery`,
      "dataValidateFils": {surfaceEmplacementId: this.props.surfaceEmplacementId, caddies: this.props.caddies, delete: isDevalidation, creationId: this.props.fileRegisteredCreationId},
      "routeMiniatureFils": `${getHostApi()}/customers/${getUserId()}/orders/${this.props.idCommande}/image-files?numCommande=${this.props.numCommande}&path=travail.auto/embroidery/&validated=true&xsrf=${localStorage.getItem('xsrfToken')}&cache=${Date.now()}`
    }
    if(isDeleteFile) {
        putUploadRequest(data.routeValidateFils, {...data.dataValidateFils}).then((response: any) => {
          if (response.data) {
            this.props.handleDisplayChargement(false);
            this.setState({
              displayChargement: false
            });
          }
        }).catch((error) => {
      console.log(error);
    });
  }
    return data;
  }

  _fetchDataFilsExist = (idCaddies: string) => {
    const baseUrl = baseUrlEmbrodery(idCaddies,this.props.idCommande, this.props.surfaceId, this.props.emplacementId, this.props.fileRegisteredId );
    const data = {
      "routeFetchFils":`${baseUrl}embroidery/exist`,
      "tiff": `${this.props.fileRegisteredCreationId}-${this.props.surfaceEmplacementId}.tiff`
    }
    return data;
  }

  _displayMiniatureBroderie = (srcMinia: string) => {
    this.setState({
      broderieMiniatureSrc: `${srcMinia}&cache=${Date.now()}`
    })
  }

  _fetchFilsBroderie = (idCaddies: string, tolerance: number = 15, onlyInBdd: boolean = false, isExist: boolean = false) => {
    this.props.handleDisplayChargement(true);
    this.setState({
      displayChargement: true
    });
    if(isExist) {
      this._fetchFilsExist(this.state.idCaddies);
    } else {
      this.props.handleDisplayChargement(true);
      const nbCouleurs = (!onlyInBdd && this.state.activateNbCouleurs && tolerance === 15) ? this.props.numberfils : null;
      if((nbCouleurs !== null && nbCouleurs > 0) || onlyInBdd || !this.state.activateNbCouleurs || (this.state.activateNbCouleurs && tolerance !== 15)) {
        const url = this._dataFilsBroderie(idCaddies, tolerance, onlyInBdd, nbCouleurs);
        getUploadRequest(url.routeFetchFils).then((response: any) => {
          if (response.data) {
            this.setState({
              filsBroderie: response.data.fils, broderieValide: response.data.inserted
            }, () => {
              for (const key of Object.keys(this.state)) {
                if(key.includes('filsProche-')) {
                  this.setState({[key]: []});
                }
              }
              this._fetchMiniaturesBroderie(url, onlyInBdd);
              if(this.state.filsBroderie[0]) {
                this.props.setBroderieId(this.state.filsBroderie[0].idGalerieFichierVariablesId);
                this.props.setBroderieValide(this.state.broderieValide);
                this.props.defineNbCouleursMax(response.data.nbCouleursMax ?? 8, this.state.filsBroderie.length);
              } else {
                this.props.setBroderieId(null);
                this.props.handleDisplayChargement(false);
                if(this.state.activateNbCouleurs && !onlyInBdd) {
                  alert("Erreur à la récupération des couleurs de fils. Veuillez adapter votre visuel ou saisir un nombre de couleurs plus élevé.");
                }
              }
            });
          }
        }).catch((error) => {
          console.log(error);
        });
      } else {
        this.props.handleDisplayChargement(false);
      }
    }
  }

  _fetchMiniaturesBroderie = (url: any, onlyInBdd: boolean = false) => {
    if(this.state.filsBroderie[0]?.miniaturePrincipale) {
      const ulrMiniaPrincipale = `${url.routeMiniatureFils}&nom=${this.state.filsBroderie[0].miniaturePrincipale}`;
      getUploadRequest(ulrMiniaPrincipale).then((response: any) => {
        this.props.handleDisplayChargement(false);
        this.setState({
          displayChargement: false
        });
        this.setState({
          broderieMiniaturePrincipaleSrc : `${ulrMiniaPrincipale}&cache=${Date.now()}`
        }, () => { this._displayMiniatureBroderie(this.state.broderieMiniaturePrincipaleSrc); })
      });
    }
    for (const data of this.state.filsBroderie) {
      const ulrMinia = `${url.routeMiniatureFils}&nom=${data.miniature}&cache=${Date.now()}`;
      data.url = ulrMinia;
    }
    if(onlyInBdd) {
      this.props.handleDisplayChargement(false);
      this.setState({
        displayChargement: false
      });
    }
  }

  _validateFilsBroderie = (idCaddies: string, isDevalidation: boolean = false) => {

    this.props.handleDisplayChargement(true);
    this.setState({
      displayChargement: true
    });
    const url = this._validateDataFilsBroderie(idCaddies, isDevalidation);
    putUploadRequest(url.routeValidateFils, {...url.dataValidateFils, filsBroderie: this.state.filsBroderie}).then((response: any) => {
      if (response.data) {
        this._validationFils(url, isDevalidation);
        for (const key of Object.keys(this.state)) {
          if(key.includes('filsProche-')) {
            this.setState({[key]: []});
          }
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  _validationFils = (url: any, isDevalidation: boolean = false) => {
    this.props.handleDisplayChargement(false);
    this.setState({
      displayChargement: false
    });
    if (!isDevalidation) {
      for (const data of this.state.filsBroderie) {
        data.url = `${url.routeMiniatureFils}&nom=${data.miniature}&cache=${Date.now()}`;
        this.setState({
          broderieValide: true
        }, () => {this.props.getPreview(this.state.idCaddies,true, true);})
      }
    } else {
      this.setState({
        filsBroderie: [],
        broderieValide: false,
        broderieMiniaturePrincipaleSrc: "",
        tolerance: 15
      }, () => {this.props.getPreview(this.state.idCaddies,true, true);})
    }
    this.props.setBroderieId(this.state.filsBroderie[0]?.idGalerieFichierVariablesId);
    this.props.setBroderieValide(this.state.broderieValide);
  }

  _setTolerance = (tolerance: number, event?: React.MouseEvent<HTMLButtonElement>, isBtn: boolean = false) => {
    if(tolerance < 0) { tolerance = 0;}
    if(tolerance > 30) { tolerance = 30;}
    this.setState({
      tolerance: tolerance
    }, () => {
      if(isBtn && event) {
        if (this.timeoutBtns) {
          clearTimeout(this.timeoutBtns);
        }
        this.timeoutBtns = setTimeout( () => {
            this._fetchFilsBroderie(this.state.idCaddies, this.state.tolerance, false);
        }, 500);
      }
    });
  }

  _fetchFilsProcheBroderieFromReference = (idCaddies: string, referenceFil: number, isRecherche: boolean = false) => {
    const url = this._dataFilsProcheBroderieFromReference(idCaddies, referenceFil);
    const name = `filsProche-${referenceFil}`;
    if(this.state[name]?.length > 0 && !isRecherche) {
      this.setState({
        [name]: []
      });
    } else {
      getUploadRequest(url.routeFetchFils).then((response: any) => {
        if (response.data) {
          this.setState({
            [name]: response.data
          });
          if(isRecherche) {
            this.setState({
              searchedFil: referenceFil
            });
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  _updateFilsProcheBroderieFromReference = (idCaddies: string, oldReferenceFil: number, referenceFil: number, codeHexa: string, fluorescent:boolean,  metallique: boolean) => {
    const url = this._updateDataFilsProcheBroderieFromReference(idCaddies, referenceFil);
    const lstFils = this.state.filsBroderie.map((elt: {fil: number}) => { if(elt.fil !== oldReferenceFil) { return elt.fil } else { return referenceFil } });
    const lstFilsData = this.state.filsBroderie.map((elt: {fil: number, hexadecimal: string, fluorescent: boolean, metallique: boolean}) => { if(elt.fil !== oldReferenceFil) { return {reference_fil: {code_hexa: elt.hexadecimal.split("#")[1], madeira: elt.fil, fluorescent: elt.fluorescent, metallique: elt.metallique } }} else { return {reference_fil: {code_hexa: codeHexa, madeira: referenceFil, fluorescent: fluorescent, metallique: metallique } } }});


      this.props.handleDisplayChargement(true);
      this.setState({
        displayChargement: true
      });
      postUploadRequest(url.routeFetchFils, {
        newFil: referenceFil,
        oldFil: oldReferenceFil,
        lstFils: lstFils,
        lstFilsData: lstFilsData,
        galerieFichierVariablesId: this.state.filsBroderie[0].idGalerieFichierVariablesId,
        creationId: url.creationIdSurface}).then((response: any) => {
        if (response.data) {
          const lstFilsBroderie = this.state.filsBroderie.map((elt: { fil: number, idGalerieFichierVariablesId: number, hexadecimal: string, fluorescent: boolean, metallique: boolean, alias: number | null, miniature: string, miniaturePrincipale: string }) => {
            const alias = response.data.alias;
            if(elt.fil !== oldReferenceFil) {
              elt.alias = alias;
              if(alias > 0) {
                elt.miniature = `${this.state.filsBroderie[0].idGalerieFichierVariablesId}_production_palette${alias}_${elt.fil}.png`;
                elt.miniaturePrincipale = `${this.state.filsBroderie[0].idGalerieFichierVariablesId}_production_palette${alias}_fichier.png`;
              }
              return elt
            } else {
              const miniature = `${this.state.filsBroderie[0].idGalerieFichierVariablesId}_production_palette${alias}_${referenceFil}.png`;
              return {
                fil: referenceFil,
                idGalerieFichierVariablesId: this.state.filsBroderie[0].idGalerieFichierVariablesId,
                hexadecimal: `#${response.data.code_hexa}`,
                fluorescent: fluorescent,
                metallique: metallique,
                miniature: miniature,
                miniaturePrincipale: `${this.state.filsBroderie[0].idGalerieFichierVariablesId}_production_palette${alias}_fichier.png`,
                url: `${url.routeMiniatureFils}&nom=${miniature}&cache=${Date.now()}`,
                libelle: response.data.libelle,
                alias: alias
              }
            }
          });

          this.props.handleDisplayChargement(false);
          this.setState({
            displayChargement: false,
          });
          this.setState({
            filsBroderie: lstFilsBroderie,
            broderieMiniaturePrincipaleSrc: `${url.routeMiniatureFils}&nom=${lstFilsBroderie[0].miniaturePrincipale}&cache=${Date.now()}`
          }, () => { this._displayMiniatureBroderie(this.state.broderieMiniaturePrincipaleSrc) });
        }
      }).catch((error) => {
        console.log(error);
      });
  }

  _fetchFilsExist = (idCaddies: string) => {
    const baseUrl = baseUrlEmbrodery(idCaddies,this.props.idCommande, this.props.surfaceId, this.props.emplacementId, this.props.fileRegisteredId );
    const url = fetchDataFilsExist(idCaddies, baseUrl, this.props.fileRegisteredCreationId, this.props.surfaceEmplacementId, this.props.traitementContour, this.props.galerieFichierVariableId);
    postUploadRequest(url.routeFetchFils, {tiff: url.tiff, traitementContour: this.props.traitementContour, isReuse: true}).then((response: any) => {
      if (response && response.data) {
        if(this.props.wantReUseFils) {
            this.setState({
              filsBroderie: response.data.fils, inserted: response.data.inserted
            });
            const url = this._dataFilsBroderie(idCaddies, 15, true, null);
            if(this.state.filsBroderie[0]?.miniaturePrincipale) {
              this.props.handleDisplayChargement(false);
              this.setState({
                displayChargement: false
              });
              const ulrMiniaPrincipale = `${url.routeMiniatureFils}&nom=${this.state.filsBroderie[0].miniaturePrincipale}`;
              axios.get(ulrMiniaPrincipale, getRequestConfig()).then((response) => {
                this.setState({
                  broderieMiniaturePrincipaleSrc : `${ulrMiniaPrincipale}&cache=${Date.now()}`
                })
              });
            }
            for (const data of this.state.filsBroderie) {
              const ulrMinia = `${url.routeMiniatureFils}&nom=${data.miniature}&cache=${Date.now()}`
              data.url = ulrMinia;
            }
            this.props.setBroderieId(this.state.filsBroderie[0].idGalerieFichierVariablesId);
            this.props.setBroderieValide(this.state.broderieValide);
            this.props.defineNbCouleursMax(response.data.nbCouleursMax ?? 8, this.state.filsBroderie.length);
        } else {
          this._fetchFilsBroderie(this.state.idCaddies, this.state.tolerance, false, false);
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  private _updateSearchedFil(value : number) {
      if(value > 999 && value < 9999) {
        this._fetchFilsProcheBroderieFromReference(this.state.idCaddies, value, true);
      }
  }

  private _confirmChangeFils = () => {
    this.setState({openModaleConfirmChangeFils : !this.state.openModaleConfirmChangeFils}, () => {
      this._updateFilsProcheBroderieFromReference(this.state.idCaddies, this.state.oldReferenceFil,this.state.referenceFil, this.state.codeHexa, this.state.fluorescent, this.state.metallique);
    });
  }

  private toggleModale = () => {
    this.setState({openModaleConfirmChangeFils : !this.state.openModaleConfirmChangeFils});
  }

  private changeFil = (oldReferenceFil: number, referenceFil: number, codeHexa: string, fluorescent:boolean,  metallique: boolean) => {
    this.setState({openModaleConfirmChangeFils : !this.state.openModaleConfirmChangeFils,  oldReferenceFil: oldReferenceFil, referenceFil: referenceFil, codeHexa: codeHexa, fluorescent: fluorescent, metallique: metallique});
  }

  render() {
    const renderTableFils = () => {
      const bgColor = this.props.bgColor;
      const html = [];
      let styleMinBroderie = {};
      if (this.state.filsBroderie) {
        const heightMiniature = this.state.filsBroderie.length >= 2 ? '200px' : 'unset';
        styleMinBroderie = {height : heightMiniature,background: bgColor};
        html.push(
          <thead className={"text-center"}>
          <td colSpan={1} style={{borderColor: "black"}} className="align-middle">
            <span>Aperçu d'origine :</span>
            <div  className={'d-flex align-items-center justify-content-center'}>
              <img className={"p-3"} src={`${this.props.pathBatOriginal}`} style={styleMinBroderie}/>
            </div>
          </td>
          <td colSpan={3} style={{borderColor: "black"}}>
            <span>Aperçu des couleurs de fils :</span>
            <div  className={'d-flex align-items-center justify-content-center'}>
              <img className={"p-3"} id="miniatureBroderie" src={`${this.state.broderieMiniatureSrc ?? this.state.broderieMiniaturePrincipaleSrc}`} style={styleMinBroderie}/>
            </div>
            {this.props.dimensions  &&
              <div className={`bg-white black text-center py-1 `}>
                <span className="px-1">{this.props.dimensions.largeur}cm x {this.props.dimensions.hauteur}cm</span>
              </div>
            }
          </td>
          </thead>,
          <tr className="bg-black white text-center">
            <td colSpan={4} className={'align-middle'}>
              <div className={'d-flex justify-content-center align-items-center'}>
                {this.state.displayChargement ? <BounceLoader loading={this.state.displayChargement} /> :
                  <>
                    <span> {this.state.filsBroderie.length} couleur(s) de fils</span>
                    {this.props.isInternalUserNotCustomerView && <span className={"small italic ml-1"}>Broderie n°{this.state.filsBroderie[0].idGalerieFichierVariablesId}</span>}
                  </>}
              </div>
              {(this.state.filsBroderie && this.state.filsBroderie.length >=1 && !this.state.broderieValide && (!this.props.validationBat || this.props.reuploadBtnAdminBatValide))  &&
                <>
                  <div className={"small italic d-none grey text-center"}>Tolérance <span className={'d-none'}>{this.state.tolerance}</span></div>
                  <div className={'d-flex align-items-center justify-content-center'}>
                    <span className={"align-top col-xs-6 pl1 text-right small grey "}>
                      <span className={"pr1"}>- de fils</span>
                      <span className={'d-none'}>30</span>
                      <button className={"btn bg-white font12"} style={{height: "2.5em", width: "2.5em", borderRadius: 999}} onClick={(event) => {this._setTolerance(parseInt(this.state.tolerance,10) + 1, event,true);}}>-</button>
                    </span>
                    <input className={"inputRangeEmbrodery"} type="range" title={"Tolérance"} min={0} max={30} defaultValue={15} value={this.state.tolerance} onChange={(event) => {this._setTolerance(parseInt(event.target.value,10));}}
                         onMouseUp={(event) => { this._fetchFilsBroderie(this.state.idCaddies, this.state.tolerance, false); }}/>
                    <span className={"align-top col-xs-6 pl0 small grey  pr1"}>
                      <button className={"btn bg-white font12"} style={{height: "2.5em", width: "2.5em", borderRadius: 999}} onClick={(event) => {this._setTolerance(parseInt(this.state.tolerance,10) - 1, event,true);}}>+</button>
                      <span className={"pl1"}>+ de fils</span>
                      <span className={'d-none'}>0</span>
                    </span>
                  </div>
                </>
              }
            </td>
          </tr>,
        );
        for (const data of this.state.filsBroderie) {
          let renderOptionsFilsProche = null;
          const lstFils = this.state.searchedFil && this.state[`filsProche-${this.state.searchedFil}`].length > 0 ? this.state[`filsProche-${this.state.searchedFil}`] : this.state[`filsProche-${data.fil}`];
          if(lstFils) {
            renderOptionsFilsProche = lstFils.map((elt: {
              metallique: boolean,
              fluorescent: boolean,
              fil_madeira: number, code_hexa: string, libelle: string}) => {
                return (
                  <li style={{listStyle: "none", cursor: "pointer"}}>
                    <a onClick={() => {this.changeFil(data.fil, elt.fil_madeira, elt.code_hexa, elt.fluorescent, elt.metallique)}}>
                      <span className={"pl2 pr2"} title={`Hexadecimal : ${elt.code_hexa}`}
                            style={{border: "1px solid black", backgroundColor: `#${elt.code_hexa}`}}>&nbsp;</span>
                      <span className={"bold pl1"}>{elt.fil_madeira}</span>
                      <span className={"pl1"}>{elt.libelle}</span>
                      {elt.fluorescent &&
                        <span className={'ml-1'}>(fil fluorescent)</span>
                      }
                      {elt.metallique &&
                        <span className={'ml-1'}>(fil métallique)</span>
                      }
                    </a>
                  </li>
                );
            });
          }

          const widthMiniatureFil = this.state.filsBroderie.length >= 5 ? '25px' : '100px';
          const styleMinBroderieFil = {width : widthMiniatureFil,background: bgColor};
          html.push(
            <>
              <tr>
                <td className={'align-middle'}>
                  <span className={"pl2 pr2"} title={`Hexadecimal : ${data.hexadecimal}`}
                    style={{border: "1px solid black", backgroundColor: `${data.hexadecimal}`}}>&nbsp;</span>
                </td>
                <td className={'align-middle'}>
                  <span>{data.libelle} - fil madeira Polynéon 40 n°{data.fil}{data.fluorescent ? " - fluorescent": ""}{data.metallique ? " - métallique" :""}
                  </span>
                </td>
                <td className="cursor-pointer align-middle" onMouseEnter={() => {
                  this._displayMiniatureBroderie(data.url)
                }} onMouseLeave={() => {
                  this._displayMiniatureBroderie(this.state.broderieMiniaturePrincipaleSrc)
                }}>
                  <img src={`${data.url}`} className={"p-1"} style={styleMinBroderieFil}/>
                </td>
                <td className={'align-middle'}>
                  {!this.state.broderieValide && <button className={'align-items-center text-center d-flex btnBatAuto btnBatAutoPrimary justify-content-center py-3  black text-center w-100    cursor-pointer'} onClick={() => {this._fetchFilsProcheBroderieFromReference(this.state.idCaddies, data.fil)}}>{this.state[`filsProche-${data.fil}`]?.length > 0 ? "Masquer les références" : "Modifier"}</button>}
                </td>
              </tr>
              {this.state[`filsProche-${data.fil}`]?.length > 0 && <tr id={`filsProche-${data.fil}`}>
                <td colSpan={4}>
                  <div style={{overflowY: "hidden", height: 200, textAlign: "initial"}}>
                    <div className={"d-flex"}>
                      <label className={"align-items-center w50 d-flex"}>Recherche par référence:</label>
                      <input type={"search"} max={9999} placeholder={"Référence de fil (exemple: 1800)"} className={"d-flex form-control align-items-center"} onChange={(event) => {    if(parseInt(event.target.value,10) > 999) {
                            this._updateSearchedFil(parseInt(event.target.value,10));
                          } else if(event.target.value === "") {
                            this._updateSearchedFil(data.fil);
                          }
                        }
                      }/>
                    </div>
                    <div className={"my-2 border-bottom-dotted"}/>
                    <div style={{overflowY: "scroll", height: 200, textAlign: "initial"}}>
                      <ul>
                        {renderOptionsFilsProche}
                      </ul>
                    </div>
                  </div>
                </td>
              </tr>}
            </>,
          );
        }
      }
      return (html);
    }
    return (
      <div className="p-2">
        {this.state.filsBroderie?.length > 0 && (
          <div className={"text-center w-100 align-items-center align-self-center justify-content-center mx-auto"}>
            <table className="table pa1 borderBlack mt1 mb0">{renderTableFils()}</table>
            <div className={"text-right italic mt1"}>
              <Icons icon="help" size={15} color="black" className=""/>
              <span className={"pl05"}><a className={'grey text-underline'} download href={'/lib/pdf/MADEIRA_POLYNEON.pdf'}>Télécharger le nuancier des fils Madeira</a></span>
              <div className={"small"}>Nous utilisons exclusivement la gamme Madeira Polyneon 40. Les couleurs sont données à titre indicatif.</div>
              <Modal open={this.state.openModaleConfirmChangeFils} onClose={() => this.toggleModale() } center classNames={{overlay: 'bootstrap-container', modal: 'deleteFileModalContainer customModal', closeButton: 'deleteFileModalCloseButton closeButton'}}>
                <div className="p-2">
                  <p className="text-center font18 bold">Souhaitez-vous vraiment remplacer cette référence de fil ?</p>
                  <button title="Annuler" onClick={() => this.toggleModale() }
                          className="border-0 bold bg-white cursor-pointer border-dark btnCancelModal float-left py-2 px-3">
                    Non
                  </button>
                  <button  onClick={() => this._confirmChangeFils()}
                           className="border-dark border bold bg-white cursor-pointer btnValidateModal float-right py-2 px-3">
                    Oui
                  </button>
                </div>
              </Modal>
            </div>
          </div>
        )}
      </div>
    );
  }
}